// @flow
import * as React from 'react';
import {Input} from "./Input";
import {Button} from "./Button";
import {usePlans} from "../contexts/Plans";
import {PlansApi} from "../api/plans";
import Swal from "sweetalert2";
import {ReactComponent as Check} from '../assets/check.svg';
import {toBrl} from "../services/functions";
import app from "../App";

type Props = {

};
export const DiscountTicket = (props: Props) => {
    const {applyTicket, discountTicket, selectedPlan, loadingTicket} = usePlans();
    const [value, setvalue] = React.useState<string>('');

    const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value.toUpperCase();
        setvalue(value);
    }

    return (
        <div>
            <div className="flex gap-1 items-end">
                <div className="w-full">
                    <Input
                        value={discountTicket ? discountTicket.nome : value}
                        className={`pr-4 ${discountTicket ? 'cursor-not-allowed' : ''}`}
                        onChange={onChange}
                        disabled={discountTicket !== null}
                        label={"Cupom de desconto"}
                        placeholder="CÓDIGO"
                    />
                </div>
                <Button
                    onClick={() => applyTicket(value)}
                    className="btn h-10 w-28"
                    loading={loadingTicket}
                    disabled={!value || discountTicket !== null}
                    type="button"
                >
                    {discountTicket !== null ? 'Aplicado' : 'Aplicar'}
                </Button>
            </div>
            {discountTicket !== null && (
                <div className="flex items-center pl-8 relative text-14 text-tertiary font-bold">
                    <Check className="absolute left-2"/>
                    {discountTicket.tipo_desconto === 'valor' ? (
                        <>- {toBrl(discountTicket.desconto)} de desconto</>
                    ) : (
                        <>
                            {discountTicket.desconto} % de desconto |
                            - {toBrl(selectedPlan!.valor * (discountTicket.desconto / 100))}
                        </>
                    )}
                </div>
            )}
        </div>
    );
};